import { Directive, ElementRef, Input, inject } from '@angular/core';

/**
 * Smoothly fades the host element in whenever its bound value changes after the first paint.
 * Used so a thread title swapping from the "Untitled chat" placeholder to the generated title
 * appears smoothly instead of snapping. The first value is shown instantly (no animation) so
 * existing, already-titled threads don't flicker on load.
 */
@Directive({ selector: '[wbTitleReveal]', standalone: true })
export class TitleRevealDirective {

  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private current: string | null = null;

  @Input('wbTitleReveal') set value(next: string) {

    const target = next ?? '';
    if (target === this.current) return;

    const isFirstPaint = this.current === null;
    this.current = target;
    if (isFirstPaint) return; // Only animate real changes, not the initial render.

    const el = this.el.nativeElement;
    el.classList.remove('title-reveal');
    void el.offsetWidth; // force reflow so the animation restarts on each change
    el.classList.add('title-reveal');
  }
}
